module.exports = __webpack_public_path__ + "static/media/flower.a8017ec1.svg";